import { render } from "./QuieroEsteCupon.vue?vue&type=template&id=f05cab9c&scoped=true"
import script from "./QuieroEsteCupon.vue?vue&type=script&lang=js"
export * from "./QuieroEsteCupon.vue?vue&type=script&lang=js"

import "./QuieroEsteCupon.vue?vue&type=style&index=0&id=f05cab9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05cab9c"]])

export default __exports__